import { Injectable } from '@angular/core';
import { DataGridColumns } from '@app/shared/models';
import { Observable } from 'rxjs';
import { environment } from '@app/environment';
import { IPermitSearch, IPermit } from '@shared/interfaces/index';
import { Dialogs, IDataGridDialogOptions } from '@m27/common';
import { Http } from '@core/http/http';
import { IPermitKey } from '@permitting/interfaces/permit';

@Injectable({
    providedIn: 'root'
})
export class MainMenuService {
    public unviewedReports: { [ReportId: number]: boolean } = {};  // dictionary like

    constructor(private http: Http) { }

}
